<template>
	<div>
		<el-dialog :title="editForm.id==null||editForm==''?$t('deng-ji-chong-dian-zhan'):$t('bian-ji-chong-dian-zhan')" width="900px" :visible="editFormVisible"
			:close-on-click-modal="false" :close-on-press-escape="editForm.id!=null&&editForm!=''"
			:modal-append-to-body='false' :before-close="clearEditForm">
			<!--外部对话框 form-->
			<el-form :model="editForm" ref="editForm" :rules="editFormRules" size="mini" class="edit_form">
        <el-divider content-position="left"><i class="el-icon-caret-right"></i>基础信息配置</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('chong-dian-zhan-ming-cheng')" :label-width="formLabelWidth" prop="stationName">
              <el-input v-model="editForm.stationName" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('chong-dian-zhan-lei-xing')" :label-width="formLabelWidth" prop="stationType">
              <el-select :placeholder="$t('chong-dian-zhan-lei-xing-0')" v-model="editForm.stationType">
                <el-option v-for="item in stationTypeData" :key="item.value" v-bind:label="item.message"
                           v-bind:value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('chong-dian-zhan-zhuang-tai')" :label-width="formLabelWidth" prop="stationStatus">
              <el-select :placeholder="$t('siteManager.stationStatus')" v-model="editForm.stationStatus">
                <el-option v-for="item in stationStatusData" :key="item.value" v-bind:label="item.message"
                           v-bind:value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--          <el-col :span="12">-->
          <!--            <el-form-item label="桩数量" :label-width="formLabelWidth" prop="pileCount">-->
          <!--              <el-input v-model="editForm.pileCount" autocomplete="off"></el-input>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <!--          <el-col :span="12">-->
          <!--            <el-form-item label="是否启用" :label-width="formLabelWidth" prop="canUse">-->
          <!--              <el-select placeholder="请选择" v-model="editForm.canUse">-->
          <!--                <el-option v-for="item in canUseData" :key="item.value"-->
          <!--                           v-bind:label="item.message" v-bind:value="item.value"></el-option>-->
          <!--              </el-select>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <el-col :span="12">
            <el-form-item :label="$t('yun-ying-shang')" :label-width="formLabelWidth" prop="operatorId">
              <!--          <el-select placeholder="运营商" v-model="editForm.operatorId">
              <el-option v-for="item in operatorForSelect" :key="item.id" :disabled="operatorDisable(item)"
                         v-bind:label="item.name" v-bind:value="item.id"></el-option>
            </el-select>-->
              <el-cascader size="mini" ref="cascader" :placeholder="$t('deviceControl.operatorId')" filterable
                           :options="this.setTreeDisable(this.operatorForSelect)"
                           :props="{ checkStrictly:true,expandTrigger:'hover'}" :show-all-levels="false"
                           change-on-select @change='handleChangeOperator' v-model="editForm.operatorId">
              </el-cascader>
            </el-form-item>
          </el-col>
          <template v-if="editForm.operatorId">
            <el-col :span="24">
              <el-divider content-position="left"><i class="el-icon-caret-right"></i>场站支付渠道</el-divider>
            </el-col>
            <el-col :span="12" v-for="item in stationPaymentTypeOptions" :key="item.code">
              <el-form-item :label="item.label" :label-width="formLabelWidth">
                <el-select clearable v-model="stationPaymentSelection[item.code]" placeholder="请选择场站支付渠道" @change="syncStationPaymentConfig">
                  <el-option v-for="channel in (stationPaymentChannelMap[item.code] || [])" :key="channel.id"
                             :label="channel.name + (channel.channelName ? '(' + channel.channelName + ')' : '')"
                             :value="channel.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>
          <!--<el-col :span="12">
          <el-form-item label="二级运营商：" :label-width="formLabelWidth" prop="virtualId">
            <el-select placeholder="运营商" v-model="editForm.virtualId">
              <el-option v-for="item in operatorForSelect" :key="item.id"
                         :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>-->
          <el-col :span="12">
            <el-form-item :label="$t('suo-zai-sheng')" :label-width="formLabelWidth" prop="province">
              <el-input :placeholder="$t('shang-chuan-zhan-dian-di-zhi-hou-tian-chong')" disabled v-model="editForm.province" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('suo-zai-shi')" :label-width="formLabelWidth" prop="city">
              <el-input :placeholder="$t('shang-chuan-zhan-dian-di-zhi-hou-tian-chong-0')" disabled v-model="editForm.city" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('xian-qu')" :label-width="formLabelWidth" prop="area">
              <el-input :placeholder="$t('shang-chuan-zhan-dian-di-zhi-hou-tian-chong-1')" disabled v-model="editForm.area" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('xiang-xi-di-zhi-2')" :label-width="formLabelWidth" prop="address">
              <el-input autocomplete="off" :placeholder="$t('cong-you-bian-an-niu-shang-chuan-zhan-dian-di-zhi')" id="address" v-model="editForm.address">
              </el-input>
              <el-button @click="showInnerForm">{{ $t('shang-chuan') }}
                <i class="el-icon-upload el-icon--right"></i>
              </el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('jing-du')" :label-width="formLabelWidth" prop="longitude">
              <el-input :placeholder="$t('shang-chuan-zhan-dian-di-zhi-hou-tian-chong-2')" disabled autocomplete="off" v-model="editForm.longitude">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('wei-du')" :label-width="formLabelWidth" prop="latitude">
              <el-input :placeholder="$t('shang-chuan-zhan-dian-di-zhi-hou-tian-chong-3')" disabled autocomplete="off" v-model="editForm.latitude">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('fu-ze-ren')" :label-width="formLabelWidth" prop="dutyPerson">
              <el-input autocomplete="off" v-model="editForm.dutyPerson"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('fu-wu-dian-hua')" :label-width="formLabelWidth" prop="dutyPersonPhone">
              <el-input autocomplete="off" v-model="editForm.dutyPersonPhone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('yun-ying-guan-li-fei-yuan')" :label-width="formLabelWidth" prop="managementPrice">
              <el-input autocomplete="off" v-model="editForm.managementPrice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- <el-form-item label="营业时间：" :label-width="formLabelWidth" prop="businessHours"> -->
            <!-- <el-input autocomplete="off" placeholder="格式00:00-24:00" v-model="editForm.businessHours"></el-input> -->
            <el-form-item :label="$t('ying-ye-shi-jian')" :label-width="formLabelWidth">
              <el-col v-for="(item,i) in business" :key="i">
                <el-time-select class="limitedTimePicker" :placeholder="$t('kai-shi')" v-model="item[0]"
                                :picker-options="{
					  start: '00:00',
					  step: '00:10',
					  end: '24:00',
					  minTime:  i > 0 && business[i-1][1] ? business[i-1][1].split(':')[0]+':'+(business[i-1][1].split(':')[1]-1) : '',
					}"></el-time-select>
                <el-time-select class="limitedTimePicker" :placeholder="$t('jie-shu')" v-model="item[1]"
                                :picker-options="{
							  start: '00:00',
							  step: '00:10',
							  end: '24:00',
							  minTime:  i > 0 && business[i-1][1] ? business[i-1][1].split(':')[0]+':'+(business[i-1][1].split(':')[1]-1) : '',
							}"></el-time-select>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('kuai-man-chong-0')" :label-width="formLabelWidth" prop="fastOrSlow">
              <el-select :placeholder="$t('gong-yi-dong-duan-zhan-shi')" v-model="editForm.fastOrSlow">
                <el-option v-for="item in fastOrSlowData" :key="item.value" v-bind:label="item.message+$t('zhan')"
                           v-bind:value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('jiao-fu-shi-jian-0')" :label-width="formLabelWidth" prop="deliveryTime">
              <el-date-picker v-model="editForm.deliveryTime" type="date" value-format="yyyy-MM-dd" :placeholder="$t('xuan-ze-ri-qi-shi-jian')"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('bao-xiu-shi-jian-1')" :label-width="formLabelWidth" prop="warrantyPeriod">
              <el-date-picker v-model="editForm.warrantyPeriod" type="date" value-format="yyyy-MM-dd" :placeholder="$t('xuan-ze-ri-qi-shi-jian')"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('yan-bao-shi-jian-0')" :label-width="formLabelWidth" prop="extendWarranty">
              <el-date-picker v-model="editForm.extendWarranty" type="date" value-format="yyyy-MM-dd" :placeholder="$t('xuan-ze-ri-qi-shi-jian')"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('xiao-shou-ren-0')" :label-width="formLabelWidth" prop="salesman">
              <el-input autocomplete="off" v-model="editForm.salesman" :placeholder="$t('qing-tian-xie-xiao-shou-ren-ming-cheng')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('xiao-shou-ren-lian-xi-fang-shi')" :label-width="formLabelWidth" prop="salesmanPhone">
              <el-input autocomplete="off" v-model="editForm.salesmanPhone" :placeholder="$t('qing-tian-xie-xiao-shou-ren-lian-xi-fang-shi')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left"><i class="el-icon-caret-right"></i>停车收费配置</el-divider>
        <el-row>
          <!--              <el-autocomplete-->
          <!--                class="inline-input"-->
          <!--                v-model="editForm.rateGroupId"-->
          <!--                :fetch-suggestions="queryRateGroupId"-->
          <!--                placeholder="请输入内容"-->
          <!--                :trigger-on-focus="false"-->
          <!--                @select="handleSelect"-->
          <!--              ></el-autocomplete>-->
          <!--          <el-col :span="12">-->
          <!--            <el-form-item label="停车场管理单位：" :label-width="formLabelWidth" prop="parkingLotOwner">-->
          <!--              <el-input autocomplete="off" v-model="editForm.parkingLotOwner"></el-input>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <el-col :span="12">
            <!-- <el-form-item label="停车场开放时间：" :label-width="formLabelWidth" prop="parkingLotOpenHours">
              <el-input autocomplete="off" placeholder="格式00:00-24:00" v-model="editForm.parkingLotOpenHours">
              </el-input>
            </el-form-item> -->
            <el-form-item :label="$t('ting-che-chang-kai-fang-shi-jian')" :label-width="formLabelWidth">
              <el-col v-for="(item,i) in parkingLotOpen" :key="i">
                <el-time-select class="limitedTimePicker" :placeholder="$t('kai-shi-0')" v-model="item[0]"
                                :picker-options="{
					  start: '00:00',
					  step: '00:10',
					  end: '24:00',
					  minTime:  i > 0 && parkingLotOpen[i-1][1] ? parkingLotOpen[i-1][1].split(':')[0]+':'+(parkingLotOpen[i-1][1].split(':')[1]-1) : '',
					}"></el-time-select>
                <el-time-select class="limitedTimePicker" :placeholder="$t('jie-shu-0')" v-model="item[1]"
                                :picker-options="{
							  start: '00:00',
							  step: '00:10',
							  end: '24:00',
							  minTime:  i > 0 && parkingLotOpen[i-1][1] ? parkingLotOpen[i-1][1].split(':')[0]+':'+(parkingLotOpen[i-1][1].split(':')[1]-1) : '',
							}"></el-time-select>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('ying-ye-lei-xing')" :label-width="formLabelWidth" prop="businessType">
              <el-select :placeholder="$t('ying-ye-lei-xing-0')" v-model="editForm.businessType">
                <el-option v-for="item in businessTypeData" :key="item.value" v-bind:label="item.message"
                           v-bind:value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('ting-che-wei-shu-liang')" :label-width="formLabelWidth" prop="parkNum">
              <el-input autocomplete="off" v-model="editForm.parkNum"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('shi-fou-shou-qu-ting-che-fei')" :label-width="formLabelWidth" prop="isParkingFee">
              <el-select :placeholder="$t('shi-fou-shou-qu-ting-che-fei-0')" v-model="editForm.isParkingFee">
                <el-option v-for="item in YesNoEnumData" :key="item.value" v-bind:label="item.message"
                           v-bind:value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('ting-che-fei-yong-yuan-xiao-shi')" :label-width="formLabelWidth" prop="parkingLotFee">
              <div v-if="editForm.isParkingFee == 'Y'">
                <el-input autocomplete="off" v-model="editForm.parkingLotFee"></el-input>
              </div>
              <div v-else>
                <el-input autocomplete="off" value="0" disabled="disabled"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('ting-che-fei-shuo-ming')" :label-width="formLabelWidth" prop="parkingNotice">
              <el-input autocomplete="off" v-model="editForm.parkingNotice" :placeholder="$t('li-ru-mian-ting-2-xiao-shi-2-xiao-shi-hou-mei-xiao-shi-5-yuan')">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('shi-fou-qi-yong-zhan-zhuang-ji-fei')" :label-width="formLabelWidth" prop="feesTakeUpPile">
              <el-select :placeholder="$t('qi-yong-zhan-zhuang-ji-fei')" v-model="editForm.feesTakeUpPile">
                <el-option v-for="item in feesTakeUpPileData" :key="item.value" v-bind:label="item.message"
                           v-bind:value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('zhan-zhuang-ji-fei-shi-chang-fen-zhong')" :label-width="formLabelWidth" prop="takeUpTime">
              <div v-if="editForm.feesTakeUpPile == 'Y'">
                <el-input autocomplete="off" :placeholder="$t('dan-wei-fen-zhong')" v-model="editForm.takeUpTime"></el-input>
              </div>
              <div v-else>
                <el-input autocomplete="off" value="0" disabled="disabled"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('zhan-zhuang-dan-jia-yuan-fen-zhong')" :label-width="formLabelWidth" prop="takeUpPrice">
              <div v-if="editForm.feesTakeUpPile == 'Y'">
                <el-input autocomplete="off" v-model="editForm.takeUpPrice"></el-input>
              </div>
              <div v-else>
                <el-input autocomplete="off" value="0" disabled="disabled"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('zhan-zhuang-fei-shang-xian-yuan')" :label-width="formLabelWidth" prop="takeUpAmountTop">
              <div v-if="editForm.feesTakeUpPile == 'Y'">
                <el-input autocomplete="off" v-model="editForm.takeUpAmountTop"></el-input>
              </div>
              <div v-else>
                <el-input autocomplete="off" value="0" disabled="disabled"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('shi-fou-qi-yong-di-suo-ting-che-ji-fei')" :label-width="formLabelWidth" prop="feesPark">
              <el-select :placeholder="$t('qi-yong-di-suo-ting-che-ji-fei')" v-model="editForm.feesPark">
                <el-option v-for="item in feesParkData" :key="item.value" v-bind:label="item.message"
                           v-bind:value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left"><i class="el-icon-caret-right"></i>分润配置</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('shi-fou-can-yu-fen-run')" :label-width="formLabelWidth" prop="isProfit">
              <el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.isProfit">
                <el-option v-for="item in isProfitData" :key="item.value" v-bind:label="item.message"
                           v-bind:value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否及时分润" :label-width="formLabelWidth" prop="timelyProfit">
              <el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.timelyProfit">
                <el-option v-for="item in YesNoEnumData" :key="item.value" v-bind:label="item.message"
                           v-bind:value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="非及时分账开始时间" :label-width="formLabelWidth" prop="handProfitTime">
              <el-date-picker v-model="editForm.handProfitTime" :disabled="editForm.handProfitTime != null" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="手动分账开始时间"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('chou-yong-mo-shi')" :label-width="formLabelWidth" prop="profitType">
              <el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" :disabled="editForm.profitRelationshipCount > 0 ? 'disabled' : isSettProfit() " v-model="editForm.profitType">
                <el-option v-for="item in profitTypeEnum" :key="item.value" v-bind:label="item.message" v-bind:value="item.value"></el-option>
              </el-select>
              <span v-if="editForm.profitRelationshipCount > 0 ? 'true' : false" style="color:#F56C6C;font-size: 12px">{{ $t('cun-zai-fen-run-guan-xi') }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('chou-yong-lei-xing')"  :label-width="formLabelWidth" prop="extractType">
              <el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" :disabled="isSettProfit()" v-model="editForm.extractType">
                <el-option v-for="item in extractTypeEnum" :key="item.value" v-bind:label="item.message" v-bind:value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('zhi-fu-shou-xu-fei-bi-lie')" :label-width="formLabelWidth" prop="payPrice">
              <el-input autocomplete="off" :disabled="isSettProfit()" v-model="editForm.payPrice" :placeholder="$t('yu-zhi-fu-qu-dao-yi-zhi-huo-zhe-geng-gao')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('chou-yong-zhi')" :label-width="formLabelWidth" prop="extractPrice">
              <el-input autocomplete="off" :disabled="isSettProfit()" v-model="editForm.extractPrice" :placeholder="$t('dui-ying-chou-yong-lei-xing-zhi-bi-lie-xiao-yu-1')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('chong-dian-ping-tai-dai-fu-shou-xu-fei')" :label-width="formLabelWidth" prop="servicePrice">
              <el-input autocomplete="off" :disabled="isSettProfit()" v-model="editForm.servicePrice" :placeholder="$t('chong-dian-ping-tai-dai-fu-shou-xu-fei-mu-qian-gu-ding-zhi')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dai-fu-shou-xu-fei')" :label-width="formLabelWidth" prop="commissionPrice">
              <el-input autocomplete="off" :disabled="isSettProfit()" v-model="editForm.commissionPrice" :placeholder="$t('dai-fu-shou-xu-fei-mu-qian-gu-ding-zhi')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left"><i class="el-icon-caret-right"></i>功能开关配置</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('yong-jin-kai-qi-chong-dian')" :label-width="formLabelWidth" prop="commissionChargeFlag">
              <el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.commissionChargeFlag">
                <el-option v-for="item in YesNoEnumData" :key="item.value" v-bind:label="item.message"
                           v-bind:value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('shi-fou-yun-xu-kai-piao')" :label-width="formLabelWidth" prop="isInvoice">
              <el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.isInvoice">
                <el-option v-for="item in YesNoEnumData" :key="item.value"
                           v-bind:label="item.message" v-bind:value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('shi-fou-yun-xu-guan-ming')" :label-width="formLabelWidth" prop="isNaming">
              <el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.isNaming">
                <el-option v-for="item in YesNoEnumData" :key="item.value"
                           v-bind:label="item.message" v-bind:value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('shi-fou-yun-xu-ding-shi-chong-dian')" :label-width="formLabelWidth" prop="isTimingStart">
              <el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.isTimingStart">
                <el-option v-for="item in YesNoEnumData" :key="item.value"
                           v-bind:label="item.message" v-bind:value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('shi-fou-zhi-chi-yu-yue')" :label-width="formLabelWidth" prop="supportOrder">
              <el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.supportOrder">
                <el-option v-for="item in YesNoEnumData" :key="item.value" v-bind:label="item.message"
                           v-bind:value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="检查SIM过期：" :label-width="formLabelWidth" prop="simExpire">
              <el-select placeholder="请选择" v-model="editForm.simExpire">
                <el-option v-for="item in YesNoEnumData" :key="item.value" v-bind:label="item.message"
                           v-bind:value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('shi-fou-hu-lian-hu-tong')" :label-width="formLabelWidth" prop="isCec">
              <el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.isCec">
                <el-option v-for="item in isCecData" :key="item.value" v-bind:label="item.message"
                           v-bind:value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="互联互通告警推送" :label-width="formLabelWidth" prop="isCecAlarm">
              <el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.isCecAlarm">
                <el-option v-for="item in YesNoEnumData" :key="item.value" v-bind:label="item.message"
                           v-bind:value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
          <!--     互联互通的     -->
          <div v-if="editForm.isCec == 'Y'">
            <el-divider content-position="left"><i class="el-icon-caret-right"></i>互联互通配置</el-divider>
            <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('di-qu-bian-ma-0')" :label-width="formLabelWidth" prop="areaCode">
                <el-input v-model="editForm.areaCode" :placeholder="$t('hang-zheng-qu-yu-dai-ma-fei-you-bian')" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="县以下行政区划代码：" :label-width="formLabelWidth" prop="townCode">
                <el-input v-model="editForm.townCode" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('chang-zhan-mian-ji-ping-mi')" :label-width="formLabelWidth" prop="siteArea">
                <el-input autocomplete="off" v-model="editForm.siteArea"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('di-qu-lei-xing')" :label-width="formLabelWidth" prop="addressType">
                <el-select :placeholder="$t('di-qu-lei-xing-0')" v-model="editForm.addressType">
                  <el-option v-for="item in addressTypeData" :key="item.value" v-bind:label="item.message"
                             v-bind:value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('pin-pai-ming-cheng')" :label-width="formLabelWidth" prop="gdOperatorName">
                <el-input autocomplete="off" :placeholder="$t('pin-pai-ming-cheng')" maxlength="50" v-model="editForm.gdOperatorName">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('she-bei-suo-shu-fang-id')" :label-width="formLabelWidth" prop="equipmentOwnerID">
                <el-input autocomplete="off" :placeholder="$t('gong-si-zu-zhi-ji-gou-dai-ma')" v-model="editForm.equipmentOwnerID">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('chong-dian-zhan-guo-jia-dai-ma')" :label-width="formLabelWidth" prop="countryCode">
                <el-input autocomplete="off" :placeholder="$t('li-ru-cn')" v-model="editForm.countryCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('di-qu-dai-ma')" :label-width="formLabelWidth" prop="areaCode">
                <el-input autocomplete="off" :placeholder="$t('sheng-shi-qu-bian-ma-gbt-22602007')" v-model="editForm.areaCode">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('zhan-dian-dian-hua')" :label-width="formLabelWidth" prop="stationTel">
                <el-input autocomplete="off" v-model="editForm.stationTel"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('fu-wu-dian-hua-0')" :label-width="formLabelWidth" prop="serviceTel">
                <el-input autocomplete="off" v-model="editForm.serviceTel"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('zhan-dian-yin-dao')" :label-width="formLabelWidth" prop="siteGuide">
                <el-input autocomplete="off" v-model="editForm.siteGuide"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('shi-yong-che-xing-miao-shu')" :label-width="formLabelWidth" prop="matchCars">
                <el-input autocomplete="off" v-model="editForm.matchCars"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('che-wei-lou-ceng-ji-shu-liang-miao-shu')" :label-width="formLabelWidth" prop="parkInfo">
                <el-input autocomplete="off" v-model="editForm.parkInfo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="企业微信客服群key" :label-width="formLabelWidth">
                <el-input autocomplete="off" maxlength="64" v-model="editForm.kefuKey"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="即插即充描述" :label-width="formLabelWidth">
                <el-input autocomplete="off" maxlength="30" v-model="editForm.plugAndCharge"></el-input>
              </el-form-item>
            </el-col>
            <!--            <el-col :span="12">-->
            <!--              <el-form-item label="支付方式：" :label-width="formLabelWidth" prop="payment">-->
            <!--                <el-input autocomplete="off" v-model="editForm.payment"></el-input>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
            <el-col :span="12">
              <el-form-item label="是否流量场站：" :label-width="formLabelWidth" prop="isThirdparty">
                <el-select placeholder="请选择" v-model="editForm.isThirdparty">
                  <el-option v-for="item in YesNoEnumData" :key="item.value" v-bind:label="item.message"
                             v-bind:value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item :label="$t('zhou-bian-pei-tao-she-shi')"  :label-width="formLabelWidth" prop="supportingFacilities">
                <el-select v-model="editForm.supportingFacilities"  clearable multiple   :placeholder="$t('zhou-bian-pei-tao-she-shi-0')" >
                  <el-option
                    v-for="item in supportingFacilitiesData"
                    :key="item.value"
                    :label="item.message"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('zhou-bian-huan-jing')" :label-width="formLabelWidth" prop="environment">
                <el-select v-model="editForm.environment"  clearable    :placeholder="$t('zhou-bian-huan-jing-0')" >
                  <el-option
                    v-for="item in environmentData"
                    :key="item.value"
                    :label="item.message"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>


            <el-col :span="12">
              <el-form-item label="高德对接：" :label-width="formLabelWidth" prop="gaodeDock">
                <el-select placeholder="请选择" v-model="editForm.gaodeDock">
                  <el-option v-for="item in YesNoEnumData" :key="item.value" v-bind:label="item.message"
                             v-bind:value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="车主权益标签"  :label-width="formLabelWidth" >
                <el-select v-model="editForm.rightTag"  clearable multiple   placeholder="请选择车主权益标签" >
                  <el-option
                    v-for="item in rightTagsData"
                    :key="item.value"
                    :label="item.message"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="站点设施"  :label-width="formLabelWidth">
                <el-select v-model="editForm.stationFacility"  clearable multiple   placeholder="请选择站点设施" >
                  <el-option
                    v-for="item in stationFacilitysData"
                    :key="item.value"
                    :label="item.message"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="停车减免政策"  :label-width="formLabelWidth">
                <el-select v-model="editForm.parkPolicy"  clearable  placeholder="请选择停车减免政策" >
                  <el-option
                    v-for="item in parkPolicysData"
                    :key="item.value"
                    :label="item.message"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="停车费类型：" :label-width="formLabelWidth" prop="parkType">
                <el-select placeholder="请选择" v-model="editForm.parkType">
                  <el-option v-for="item in parkTypeEnumData" :key="item.value" v-bind:label="item.message"
                             v-bind:value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电费类型：" :label-width="formLabelWidth" prop="electricityType">
                <el-select placeholder="请选择" v-model="editForm.electricityType">
                  <el-option v-for="item in electricityTypeEnumData" :key="item.value" v-bind:label="item.message"
                             v-bind:value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否独立报装：" :label-width="formLabelWidth" prop="businessExpandType">
                <el-select placeholder="请选择" v-model="editForm.businessExpandType">
                  <el-option v-for="item in YesNoEnumIntegerData" :key="item.value" v-bind:label="item.message"
                             v-bind:value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报装电源容量：" :label-width="formLabelWidth" prop="capacity">
                <el-input autocomplete="off" v-model="editForm.capacity"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="站点额定总功率单位kW：" :label-width="formLabelWidth" prop="ratedPower">
                <el-input autocomplete="off" v-model="editForm.ratedPower"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="峰谷分时：" :label-width="formLabelWidth" prop="periodFee">
                <el-select placeholder="请选择" v-model="editForm.periodFee">
                  <el-option v-for="item in YesNoEnumIntegerData" :key="item.value" v-bind:label="item.message"
                             v-bind:value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="正式投运时间：" :label-width="formLabelWidth" prop="officialRunTime">
                <el-date-picker v-model="editForm.officialRunTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期时间"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="充换电站方位：" :label-width="formLabelWidth" prop="stationOrientation">
                <el-select placeholder="请选择" v-model="editForm.stationOrientation">
                  <el-option v-for="item in stationOrientationEnumData" :key="item.value" v-bind:label="item.message"
                             v-bind:value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="充换电站建设面积：" :label-width="formLabelWidth" prop="stationArea">
                <el-input autocomplete="off" v-model="editForm.stationArea"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="充换电站人工值守：" :label-width="formLabelWidth" prop="havePerson">
                <el-select placeholder="请选择" v-model="editForm.havePerson">
                  <el-option v-for="item in YesNoEnumIntegerData" :key="item.value" v-bind:label="item.message"
                             v-bind:value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="视频监控配套情况：" :label-width="formLabelWidth" prop="videoMonitor">
                <el-select placeholder="请选择" v-model="editForm.videoMonitor">
                  <el-option v-for="item in YesNoEnumIntegerData" :key="item.value" v-bind:label="item.message"
                             v-bind:value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否有小票机：" :label-width="formLabelWidth" prop="printerFlag">
                <el-select placeholder="请选择" v-model="editForm.printerFlag">
                  <el-option v-for="item in YesNoEnumIntegerData" :key="item.value" v-bind:label="item.message"
                             v-bind:value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否有道闸：" :label-width="formLabelWidth" prop="barrierFlag">
                <el-select placeholder="请选择" v-model="editForm.barrierFlag">
                  <el-option v-for="item in YesNoEnumIntegerData" :key="item.value" v-bind:label="item.message"
                             v-bind:value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否有地锁：" :label-width="formLabelWidth" prop="parkingLockFlag">
                <el-select placeholder="请选择" v-model="editForm.parkingLockFlag">
                  <el-option v-for="item in YesNoEnumIntegerData" :key="item.value" v-bind:label="item.message"
                             v-bind:value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="供电类型：" :label-width="formLabelWidth" prop="supplyType">
                <el-select placeholder="请选择" v-model="editForm.supplyType">
                  <el-option v-for="item in supplyTypeEnumData" :key="item.value" v-bind:label="item.message"
                             v-bind:value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="供电局用户编号：" :label-width="formLabelWidth" prop="residentNo">
                <el-input autocomplete="off" v-model="editForm.residentNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="表号：" :label-width="formLabelWidth" prop="wattHourMeterNo">
                <el-input autocomplete="off" v-model="editForm.wattHourMeterNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="全省唯一备案号：" :label-width="formLabelWidth" prop="recordUniqueNo">
                <el-input autocomplete="off" v-model="editForm.recordUniqueNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="外电功率：" :label-width="formLabelWidth" prop="forwardPower">
                <el-input autocomplete="off" v-model="editForm.forwardPower"></el-input>
              </el-form-item>
            </el-col>
            </el-row>
          </div>
          <div v-else></div>
				<!--隐藏id-->
				<el-col :span="12">
					<el-form-item hidden label="id" :label-width="formLabelWidth" prop="id">
						<el-input v-model="editForm.id" autocomplete="off"></el-input>
					</el-form-item>
				</el-col>
			</el-form>
			<!--footer -->
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" plain @click="clearEditForm">{{ $t('qu-xiao') }}</el-button>
				<el-button size="mini" plain type="primary" @click.native="editSubmit" :loading="editSubmitLoading">{{ $t('ti-jiao') }}
				</el-button>
			</div>
		</el-dialog>
		<!--   地图组件   -->
		<el-dialog width="40%" :visible.sync="dialogInnerVisible" :modal-append-to-body='false'>
			<!--快速搜索 form-->
			<el-form :model="innerForm" ref="innerForm" :inline="true" size="mini">
				<el-tabs v-model="innerFormName">
					<!--经纬坐标-->
					<el-tab-pane :label="$t('jing-wei-zuo-biao')" name="coordinate">
						<el-row class="el_row_input row_input">
							<el-col :span="10" class="el_col_input">
								<el-form-item :label="$t('jing-du')">
									<el-input autocomplete="off" v-model="centerTemp.lng"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="10" :offset="2" class="el_col_input">
								<el-form-item :label="$t('wei-du')">
									<el-input autocomplete="off" v-model="centerTemp.lat"></el-input>
								</el-form-item>
							</el-col>
							<!--                <el-col :span="2">-->
							<!--                  <el-form-item>-->
							<!--                    <el-button size="mini" class="el_search">搜索</el-button>-->
							<!--                  </el-form-item>-->
							<!--                </el-col>-->
						</el-row>
						<!--百度地图组件-->
						<div class="BaiduMap">
							<baidu-map class="map" :center="centerTemp" :zoom="15" :scroll-wheel-zoom="true"
								:map-style="{styleJson:styleJson}" map-type="BMAP_NORMAL_MAP" @click="getClickInfo">
								<bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true"
									:autoLocation="true"></bm-geolocation>
								<!--&lt;!&ndash;//添加一个小红点的，并将当前的经纬度写入数据中&ndash;&gt;-->
								<bm-marker :position="centerTemp"></bm-marker>
								<bm-control :offset="{width: '10px', height: '10px'}">
									<bm-auto-complete v-model="keyword" :sugStyle="{zIndex: 9999}">
										<el-input size="mini" v-model="keyword" :placeholder="$t('qing-shu-ru-di-ming-guan-jian-zi')"></el-input>
										<!-- 这里指代一个自定义搜索框组件 -->
									</bm-auto-complete>
								</bm-control>
								<bm-local-search :keyword="keyword" :auto-viewport="true"></bm-local-search>
							</baidu-map>
						</div>
						<!--内部对话框底部当前位置-->
						<el-row class="el_row_input rows_input">
							<el-col :span="24" class="el_col_input">
								<el-form-item>
									<label style="color: sienna;font-weight: bold" v-text="addressTemp"></label>
								</el-form-item>
							</el-col>
						</el-row>
					</el-tab-pane>
				</el-tabs>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" plain @click="dialogInnerVisible =false ">{{ $t('qu-xiao') }}</el-button>
				<el-button size="mini" plain type="primary" @click="confirmAddress">{{ $t('ti-jiao') }}</el-button>
			</div>
		</el-dialog>
	</div>
</template>



<script>
	import {
		validateInput,
		validatePhoneThree,
		validateTime,
		checkSomePhone
	} from '../../../../common/validator'
  import {isSP_admin, isAdmin,isOperator} from '@/common/oauth'
  import operatorPaymentApi from '@/module/systemManagement/api/operatorPayment.js'
	export default {
		name: "add",
		data() {
			return {
				editFormRules: {
					stationName: [{
						required: true,
						message: this.$t('qing-shu-ru-zhan-ming-cheng'),
						trigger: 'blur'
					}, {
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 15, true, true, false, false, false, false,
								false)
						},
						trigger: 'blur'
					}],
          addressType:  [{
            required: true,
            message: this.$t('di-qu-lei-xing'),
            trigger: 'blur'
          }],
					stationType: [{
						required: true,
						message: this.$t('qing-xuan-ze-zhan-lei-xing'),
						trigger: 'blur'
					}],
					stationStatus: [{
						required: true,
						message: this.$t('qing-xuan-ze-zhan-zhuang-tai'),
						trigger: 'blur'
					}],
					canUse: [{
						required: true,
						message: this.$t('qing-xuan-ze-shi-fou-qi-yong'),
						trigger: 'blur'
					}],
					longitude: [{
						required: true,
						message: this.$t('qing-shang-chuan-chong-dian-zhan-di-zhi'),
						trigger: 'blur'
					}],
					latitude: [{
						required: true,
						message: this.$t('qing-shang-chuan-chong-dian-zhan-di-zhi-0'),
						trigger: 'blur'
					}],
					areaCode: [{
						required: true,
						message: this.$t('qing-shu-ru-di-qu-bian-ma'),
						trigger: 'blur'
					}],
          townCode: [{
            required: true,
            message: '请输入县以下行政区划代码',
            trigger: 'blur'
          }],
					address: [{
						required: true,
						message: this.$t('qing-xuan-ze-di-zhi'),
						trigger: 'blur'
					}, {
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 127, true, false, false, false, false,
								false, false)
						},
						trigger: 'blur'
					}],
					siteArea: [{
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 15, true, false, false, false, false,
								false, true)
						},
						trigger: 'blur'
					}],
					// addressType: [{required: true, message: '请选择地区类型', trigger: 'blur'}],
					dutyPerson: [{
						required: true,
						message: this.$t('qing-shu-ru-fu-ze-ren'),
						trigger: 'blur'
					}, {
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 10, true, true, false, false, true, false,
								false)
						},
						trigger: 'blur'
					}],
					dutyPersonPhone: [{
						required: true,
						message: this.$t('qing-shu-ru-fu-wu-dian-hua'),
						trigger: 'blur'
					}, {
						validator: validatePhoneThree,
						trigger: 'blur'
					}],
					managementPrice: [{
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 15, true, false, false, false, false,
								false, true)
						},
						trigger: 'blur'
					}],
					businessHours: [{
						validator: validateTime,
						trigger: 'blur'
					}],
					// isParkingFee: [{required: true, message: '请选择是否收取停车费', trigger: 'blur'}],
					parkNum: [{
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 10, true, true, true, true, false, false,
								false)
						},
						trigger: 'blur'
					}],
					parkingLotOpenHours: [{
						validator: validateTime,
						trigger: 'blur'
					}],
					parkingLotFee: [{
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 10, true, false, false, false, false,
								false, true)
						},
						trigger: 'blur'
					}],
					// feesTakeUpPile: [{required: true, message: '请输入是否启用占桩计费', trigger: 'blur'}],
					parkingNotice: [{
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 50, true, false, false, false, false,
								false, false)
						},
						trigger: 'blur'
					}],
					takeUpTime: [{
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 10, true, true, true, true, false, false,
								false)
						},
						trigger: 'blur'
					}],
					takeUpPrice: [{
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 10, true, false, false, false, false,
								false, true)
						},
						trigger: 'blur'
					}],
					operatorId: [{
						required: true,
						message: this.$t('monitoringCenter.opsTreePlaceholder'),
						trigger: 'blur'
					}],
					// managementPrice: [{required: true, message: '请输入运营管理费', trigger: 'blur'}, {validator: isDecimalThanZero, trigger: 'blur'}],
					fastOrSlow: [{
						required: true,
						message: this.$t('qing-xuan-ze-kuai-man-chong'),
						trigger: 'blur'
					}],
					commissionChargeFlag: [{
						required: true,
						message: this.$t('qing-xuan-ze-shi-fou-yong-jin-kai-qi-chong-dian'),
						trigger: 'blur'
					}],
					isInvoice: [{required: true, message: this.$t('qing-xuan-ze-shi-fou-yun-xu-kai-piao'), trigger: 'blur'}],
          				isNaming: [{required: true, message: this.$t('qing-xuan-ze-shi-fou-yun-xu-guan-ming'), trigger: 'blur'}],
					businessType: [{
						required: true,
						message: this.$t('qing-xuan-ze-ying-ye-lei-xing'),
						trigger: 'blur'
					}],
          isThirdparty: [{required: true, message: '请选择是否流量场站', trigger: 'blur'}],
          simExpire: [{required: true, message: '请选择是否检查SIM卡过期', trigger: 'blur'}],
          supportOrder: [{required: true, message: '请选择是否开启预约', trigger: 'blur'}],
					isCec: [{
						required: true,
						message: this.$t('qing-xuan-ze-shi-fou-hu-lian-hu-tong'),
						trigger: 'blur'
					}],
					isProfit: [{
						required: true,
						message: this.$t('qing-xuan-ze-shi-fou-can-yu-fen-run'),
						trigger: 'blur'
					}],
          supportingFacilitiesData: [{ required: true, message: this.$t('qing-xuan-ze-pei-tao-she-shi'), trigger: 'blur' }],
          environment: [{ required: true, message: this.$t('qing-xuan-zhou-bian-huan-jing'), trigger: 'blur' }],
				},
				formLabelWidth: '150px',
				// 百度地图初始化数据
				dialogInnerVisible: false, // 内部对话框
				innerForm: {},
				innerFormName: 'coordinate',
				styleJson: [ // 百度地图自定义
					{
						'featureType': 'water',
						'elementType': 'all',
						'stylers': {
							'color': '#ffffff'
						}
					}
				],
				baidumapSwitch: false,
				zoom: 16,
				location: this.$t('shang-hai-shi'),
				keyword: '',
				centerTemp: {
					lng: 121.384555,
					lat: 31.069087
				},
				// 设置center属性值
				provinceTemp: '',
				cityTemp: '',
				districtTemp: '',
				addressTemp: '',
				// 营业时间
				business: [
					["00:00", "24:00"]
				],
				// 停车场开放时间
				parkingLotOpen: [
					["00:00", "24:00"]
				],
        stationPaymentTypeOptions: [
          { code: 'weixin', label: '微信(即充即退)' },
          { code: 'ali', label: '支付宝小程序' },
          { code: 'alipay', label: '支付宝' }
        ],
        stationPaymentChannelMap: {},
        stationPaymentSelection: {},
        supportingFacilitiesData: [
          { value: 0, message: this.$t('qi-ta-0') },
          { value: 1, message: this.$t('wei-sheng-jian') },
          { value: 2, message: this.$t('xiu-xi-shi') },
          { value: 3, message: this.$t('bian-li-dian') },
          { value: 4, message: this.$t('zi-dong-xi-che') },
          { value: 5, message: this.$t('ren-yuan-zhi-shou') },
        ],
        environmentData: [
          { value: 1, message: this.$t('di-shang') },
          { value: 2, message: this.$t('di-xia') },
          { value: 3, message: this.$t('di-shang-di-xia') },
        ],
        rightTagsData: [
          { value: 1, message: '沃尔沃车主权益' },
          { value: 2, message: '大众智选' },
          { value: 3, message: '大众精选' },
          { value: 4, message: '新人立减' },
          { value: 5, message: '送优惠卷' },
          { value: 6, message: '月卡优惠' },
          { value: 7, message: '会员优惠' },
        ],
        stationFacilitysData: [
          { value: 1, message: '卫生间' },
          { value: 2, message: '洗车免费' },
          { value: 3, message: '休息室' },
          { value: 4, message: '雨棚' },
          { value: 5, message: '有人值守' },
          { value: 6, message: 'etc' },
          { value: 7, message: '大车能充电' },
          { value: 8, message: '饮用水' },
          { value: 9, message: '自动售货机' },
          { value: 10, message: '共享充电宝' },
        ],
        parkPolicysData: [
          { value: 1, message: '收费且无优惠政策' },
          { value: 2, message: '限时停车减免，需要输入车牌' },
          { value: 3, message: '限时停车减免，需要车牌+充电消费凭证/配合小票机' },
          { value: 4, message: '限时停车减免，无需预传车牌' },
          { value: 5, message: '完全停车减免，需要输入车牌' },
          { value: 6, message: '完全停车减免，需要车牌+充电消费凭证/配合小票机' },
          { value: 7, message: '完全停车减免，无需预传车牌' },
        ],
        YesNoEnumIntegerData: [
          {value: 1, message: '是'},
          {value: 0, message: '否'}
        ],
        supplyTypeEnumData: [
          {value: 1, message: '直供电'},
          {value: 2, message: '转供电'}
        ],
        parkTypeEnumData: [
          {value: 0, message: '免费'},
          {value: 1, message: '不免费'},
          {value: 2, message: '限时免费停车'},
          {value: 3, message: '充电限时减免'},
          {value: 255, message: '参考场地实际收费标准'}
        ],
        electricityTypeEnumData: [
          {value: 1, message: '商业用电'},
          {value: 2, message: '普通工业用电'},
          {value: 3, message: '大工业用电'},
          {value: 4, message: '其他用电'}
        ],
        stationOrientationEnumData: [
          {value: 1, message: '地面-停车场'},
          {value: 2, message: '地面-路侧'},
          {value: 3, message: '地下停车场'},
          {value: 4, message: '立体式停车楼'}
        ],
			}
		},
		methods: {
      isSettProfit() {
        return !(isSP_admin() || isAdmin() || isOperator())
      },
			operatorDisable(item) {
				// 判断是否为潜在运营商
				const flag = (item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved')) ? true :
					false
				return flag
			},
			//对数据进行授权过滤
			setTreeDisable(val) {
				console.log(999999)
				console.log(val)
				//对 treeList 进行递归操作，禁止选中unchecked和unapproved
				val && val.forEach(item => {
					if ((item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved'))) {
						item.disabled = true; // 如果类型为unchecked或者unapproved，就增加禁用选项
					}
					if (item.children) {
						this.setTreeDisable(item.children);
					}
				});
				return val;
			},
			handleChangeOperator(value) {
				let operatorId = value && value.length > 0 ? value[value.length - 1] : ''
				this.editForm.operatorId = operatorId
				this.$refs.cascader.dropDownVisible = false
				this.loadStationPaymentChannels(operatorId)
			},
			loadStationPaymentChannels(operatorId) {
				if (!operatorId) {
					this.stationPaymentChannelMap = {}
					return
				}
				operatorPaymentApi.listStationPayment({ operatorId: operatorId }).then(res => {
					const list = (res && res.data) ? res.data : []
					const map = { weixin: [], ali: [], alipay: [] }
					list.forEach(item => {
						if (map[item.channelCode]) {
							map[item.channelCode].push(item)
						}
					})
					this.stationPaymentChannelMap = map
				})
			},
			initStationPaymentSelection() {
				this.stationPaymentSelection = { weixin: null, ali: null, alipay: null }
				const configs = this.editForm.stationPaymentConfig || []
				configs.forEach(c => {
					this.$set(this.stationPaymentSelection, c.paymentType, c.operatorPaymentId)
				})
			},
			syncStationPaymentConfig() {
				const configs = []
				Object.keys(this.stationPaymentSelection).forEach(type => {
					const id = this.stationPaymentSelection[type]
					if (id) {
						configs.push({ paymentType: type, operatorPaymentId: id })
					}
				})
				this.$set(this.editForm, 'stationPaymentConfig', configs)
			},
			resolveOperatorId(operatorId) {
				if (Array.isArray(operatorId)) {
					return operatorId.length > 0 ? operatorId[operatorId.length - 1] : ''
				}
				return operatorId || ''
			},
			clearEditForm() {
				let _this = this
				if (this.editForm.id == null || this.editForm == '') {
					this.$confirm(this.$t('paramMonitor.message18')).then(_ => {
						_this.$refs.editForm.clearValidate()
						_this.$emit('closeEditForm')
					}).catch(_ => {})
				} else {
					_this.$refs.editForm.clearValidate()
					_this.$emit('closeEditForm')
				}
			},
			showInnerForm() {
				this.centerTemp.lng = this.editForm.longitude == null ? 121.384555 : this.editForm.longitude
				this.centerTemp.lat = this.editForm.latitude == null ? 31.069087 : this.editForm.latitude
				this.provinceTemp = this.editForm.province
				this.cityTemp = this.editForm.city
				this.districtTemp = this.editForm.area
				this.addressTemp = this.editForm.address
				this.dialogInnerVisible = true
			},
			// 点击获取到当前经纬度
			getClickInfo(e) {
				const myGeo = new window.BMap.Geocoder()
				myGeo.getLocation(e.point, data => {
					if (data) {
						this.centerTemp = {
							lng: e.point.lng,
							lat: e.point.lat
						}
						this.provinceTemp = data.addressComponents.province
						this.cityTemp = data.addressComponents.city
						this.districtTemp = data.addressComponents.district
						this.addressTemp = data.address
					}
				})
			},
			confirmAddress() {
				//this.editForm.longitude = this.centerTemp.lng
				//this.editForm.latitude = this.centerTemp.lat
				this.editForm.province = this.provinceTemp
				this.editForm.city = this.cityTemp
				this.editForm.area = this.districtTemp
				// this.editForm.address = this.addressTemp
				/*Vue实例创建时，editForm.属性名并未声明，因此Vue就无法对属性执行 getter/setter 转化过程，
				导致editForm属性不是响应式的，因此无法触发视图更新。
				解决的方式有两种，第一种就是显示的声明editForm这个对象的属性
				* 其次也可以使用使用Vue的全局API: $set()赋值*/
				this.$set(this.editForm, 'address', this.addressTemp)
				document.getElementById("address").focus()
				document.getElementById("address").blur()
				this.$set(this.editForm, 'longitude', this.centerTemp.lng);
				this.$set(this.editForm, 'latitude', this.centerTemp.lat);
				this.$refs.editForm.clearValidate("longitude");
				this.$refs.editForm.clearValidate("latitude");
				this.dialogInnerVisible = false
			},
			// 编辑登记提交
			editSubmit() {
				this.syncStationPaymentConfig()
				this.editForm.businessHours = this.business[0][0] + '-' + this.business[0][1];
				this.editForm.parkingLotOpenHours = this.parkingLotOpen[0][0] + '-' + this.parkingLotOpen[0][1];
				let Bool = true
				console.log(this.editForm.businessHours)
				this.editForm.businessHours.split('-').forEach(item => {
					if (item == 'null') {
						Bool = false
						this.$message.error(this.$t('qing-shu-ru-ying-ye-shi-jian-duan-ge-shi-00002400'));
						return
					}
				})
				this.editForm.parkingLotOpenHours.split('-').forEach(item => {
					if (item == 'null') {
						Bool = false
						this.$message.error(this.$t('qing-shu-ru-ting-che-chang-kai-fa-shi-jian-duan-ge-shi-00002400'));
						return
					}
				})
				if(Bool){
					this.$emit('editSubmit', this.$refs.editForm)
				}
			},
		},
		props: {
			editFormVisible: {
				type: Boolean,
				required: true
			},
			editForm: {},
			editSubmitLoading: false,
			operatorForSelect: '',
			stationTypeData: '',
			stationStatusData: '',
			addressTypeData: '',
			businessTypeData: '',
			YesNoEnumData: '',
			feesTakeUpPileData: '',
      feesParkData: '',
			fastOrSlowData: '',
			isCecData: '',
			isProfitData: '',
			profitTypeEnum:'',
      extractTypeEnum: ''
		},
		watch: {
			editForm: {
				handler(newValue, oldValue) {
					console.log(newValue)
					if (newValue.businessHours&&newValue.businessHours!='-') {
						this.business = [newValue.businessHours.split('-')]
					} else {
						this.business = [
							["00:00", "24:00"]
						]
					}
					const operatorId = this.resolveOperatorId(newValue.operatorId)
					if (operatorId) {
						this.loadStationPaymentChannels(operatorId)
						this.initStationPaymentSelection()
					}
				},
				deep: true
			},
			editFormVisible(val) {
				if (val) {
					const operatorId = this.resolveOperatorId(this.editForm.operatorId)
					if (operatorId) {
						this.loadStationPaymentChannels(operatorId)
						this.initStationPaymentSelection()
					}
				}
			}
		},
	}
</script>

<style lang="less" scoped>
	.BaiduMap {
		height: 300px;

		div {
			height: 300px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/siteManager/add.vue